import React from 'react'
import { Row, Col } from 'antd';

import styles from './course.module.css'
import { NavButton } from './NavButton';
import { Typography } from 'antd';

import { graphql, useStaticQuery } from 'gatsby';


export const CourseD = () => {
    const { Text, Title } = Typography;
    

    const data = useStaticQuery(graphql`
    query{
        allContentfulProgram{
          edges{
            node{
              title
              shortDescription{
                shortDescription
              }
              image{
                fixed{
                  src
                }
              }
              technicalTrack{
                title
                courses{
                  title
                  quarter
                }
              }
              innovationTrack{
                title
                courses{
                  title
                  quarter
                }
              }
              appDevelopmentTrack{
                title
                courses{
                  title
                  quarter
                }
              }
             }
          }
        }
      }
    `)

    return (
        <div className="mn-contt">

            <div className={styles.courses_topcontent}>
            <div className={styles.edusol_heading_container}>

                <Title className={styles.sectionHeading_edusol}>
                Available Programs
                </Title>
                <Text className={styles.paragraph}>
                    <p>
                    The mission of PIAIC is to reshape Pakistan by revolutionizing education, research, and business by adopting latest, cutting-edge technologies.
                 Experts are calling this the 4th industrial revolution.
                    
                    </p>
                </Text>
            </div>


            </div>


            <div>
                <Row>
                <Col span={20} offset={2}>
                <NavButton />
                </Col>
                </Row>
                </div>


           
        </div>
    )
}